


























import Vue, { PropType } from 'vue';

import store from '@/store';

import { idGenerator } from '@/utils';
import { BasePeerGroup, WebRequestStatus } from '@/models';
import { SinglePointPacket, Objective, Badge, Outcome } from '@/models/packet';
import { OrgPeerGroup } from '@/models/orgStructure';
import * as Icons from '@/icons';

import PeerGroupList from '@/components/PeerGroupList.vue';
import SinglePointPacketEditor from '@/components/SinglePointPacketEditor.vue';

export default Vue.extend({
  components: {
    PeerGroupList,
    SinglePointPacketEditor
  },

  props: {
    packet: Object as PropType<SinglePointPacket>,
    peerGroups: Array as PropType<BasePeerGroup[]>
  },

  data() {
    return {
      createStatusTrackingId: idGenerator.next()
    };
  },

  computed: {
    objective(): Objective {
      return this.packet.objectives[0];
    },

    badges(): Badge[] {
      return store.state.badges.badges[this.objective.objectiveId] || [];
    },

    badgeStatuses(): [Badge, WebRequestStatus][] {
      return this.badges.map(b => [
        b,
        store.getters.badges.updateStatus(b.badgeId)
      ]);
    },

    inflatedGroups(): OrgPeerGroup[] {
      return this.peerGroups
        .map(pg => pg.peerGroupId)
        .map(store.getters.org.peerGroup);
    },

    createGoalStatus(): WebRequestStatus {
      return store.state.org.activeRequests.create.getStatus(
        this.createStatusTrackingId
      );
    },

    updateObjectiveStatus(): WebRequestStatus {
      return store.state.org.requestTracker.getStatus(this.packet.packetId);
    }
  },

  methods: {
    fetchBadges() {
      store.dispatch.badges.fetchBadges(this.packet.objectives[0].objectiveId);
    },

    createGoal(goal: {
      name: string;
      description: string;
      color: string;
      iconData: Icons.IconData;
    }) {
      store.dispatch.org.createSinglePointGoal({
        tempCreateId: this.createStatusTrackingId,
        packetId: this.packet.packetId,
        ...goal
      });
    },

    updateGoal(updated: { badge: Badge | null; outcome: Outcome | null }) {
      if (updated.badge) {
        store.dispatch.badges.updateBadge(updated.badge);
      }

      if (updated.outcome) {
        store.dispatch.org.updatePacketOutcome({
          packetId: this.packet.packetId,
          outcome: updated.outcome
        });
      }
    },

    deleteGoal(outcome: Outcome) {
      // Deleting the outcome cascade deletes the badge.
      //
      // Deleting fails (and should not be enabled) when there exists at least
      // one evaluation of the outcome.
      store.dispatch.org.deleteOutcome({
        packetId: this.packet.packetId,
        outcomeId: outcome.outcomeId
      });
    },

    reorderGoals(outcomes: Outcome[]) {
      store.dispatch.org.reorderOutcomes({
        packetId: this.packet.packetId,
        outcomes
      });
    },

    updateObjective(objective: Objective) {
      store.dispatch.org.updateSinglePointBasicInfo({
        trackingId: this.packet.packetId,
        packetId: this.packet.packetId,
        objective
      });
    }
  },

  watch: {
    packet(curr, prev) {
      if (curr.packetId !== prev.packetId) {
        this.fetchBadges();
      }
    }
  },

  created() {
    this.fetchBadges();
  }
});
